export const getReportPage = (payload) => {
  return {
    type: "GET_TYPE_PAGE",
    payload,
  };
};

export const getSummaryAnalysis = (payload) => {
  return {
    type: "GET_SUMMARY_ANALYSIS",
    payload,
  };
};

export const TrendAnalysis = (payload) => {
  return {
    type: "TREND_ANALYSIS",
    payload,
  };
};

export const selectedModuleAndRouteDetails = (payload) => {
  return {
    type: "SELECTED_MODULE_AND_ROUTE_DETAILS",
    payload
  };
};
export const SchemesReport = (payload) => {
  return {
    type: "Schemes_Report",
    payload,
  };
};
export const MISReport = (payload) => {
  return {
    type: "MIS_REPORT",
    payload,
  };
};
export const Summarydashboard = (payload) => {
  return {
    type: "SUMMARY_DASHBOARD",
    payload,
  };
};
export const RewardReport = (payload) => {
  return {
    type: "REWARD_REPORT",
    payload,
  };
};
export const MonthlySummary = (payload) => {
  return {
    type: "MONTHLY_SUMMARY",
    payload,
  };
};
export const FinancialYearReport = (payload) => {
  return {
    type: "FINANCIAL_YEAR_REPORT",
    payload,
  };
};
export const KycUpdationReports = (payload) => {
  return {
    type: "KYC_UPDATION_REPORTS",
    payload,
  };
};
export const DownloadReport = (payload) => {
  return {
    type: "DOWNLOAD_REPORTS",
    payload,
  };
};
export const clearFilter = (type) => ({
  type: `CLEAR_FILTER`,
  payload: type,
});
export const AddMobileNoWithNavigationFields = (mobileNo, selectedNavigation) => ({
  type: `ADD_MOBILE_NO`,
  payload: { mobileNo, selectedNavigation },
});
export const AddPassbookNoWithNavigationFields = (passbookNo, selectedNavigation) => ({

  type: `ADD_PASSBOOK_NO`,
  payload: { passbookNo, selectedNavigation },
});
export const updateSchemesDetails = (schemeDetails, schemesDatePayload) => {
  return {
    type: "UPDATE_SCHEME_DETAILS",
    payload: { schemeDetails, schemesDatePayload },
  };
};
export const updateMisDetails = (misDetailes, misdatePayload) => {
  return {
    type: "UPDATE_MIS_DETAILS",
    payload: { misDetailes, misdatePayload },
  };
};
export const updatesummaryDashboard = (
  summaryDashboard,
  summarydashboarddatePayload
) => {
  return {
    type: "UPDATE_SUMMARYDASHBOARD_DETAILS",
    payload: { summaryDashboard, summarydashboarddatePayload },
  };
};
export const updateMonthlySummary = (
  monthlySummary,
  monthlySummarydatePayload,
  id
) => {
  return {
    type: "UPDATE_MONTHLYSUMMARY_DETAILS",
    payload: { monthlySummary, monthlySummarydatePayload, id },
  };
};
export const updatefinantial = (finantial, finantiadatePayload) => {
  return {
    type: "UPDATE_FINANTIAL_DETAILS",
    payload: { finantial, finantiadatePayload },
  };
};
export const updateRewardReport = (rewardReport, rewardReportDatesPayload) => {
  return {
    type: "UPDATE_REWARDREPORT_DETAILS",
    payload: { rewardReport, rewardReportDatesPayload },
  };
};
export const updateKYCReport = (kycReport, kycReportDatesPayload) => {
  return {
    type: "UPDATE_KYCREPORT_DETAILS",
    payload: { kycReport, kycReportDatesPayload },
  };
};
export const clearKycFilter = (type) => {
  return {
    type: `CLEAR_KYC_FILTER`,
    payload: type,
  };
};
export const clearMisReportFilter = (type) => ({
  type: `CLEAR_MISREPORT_FILTER`,
  payload: type,
});
export const clearSummaryDashboardReportFilter = (type) => ({
  type: `CLEAR_SUMMARYDASHBOARD_FILTER`,
  payload: type,
});
export const clearSummaryMonthlysummaryFilter = (type) => ({
  type: `CLEAR_MONTHLYSUMMARY_DETAILS`,
  payload: type,
});
export const clearSFinantialFilter = (type) => ({
  type: `CLEAR_FINANTIAL_DETAILS`,
  payload: type,
});
export const clearRewardReportFilter = (type) => ({
  type: `CLEAR_REWARDREPORT_DETAILS`,
  payload: type,
});
export const clearDownloadFilter = (type) => ({
  type: `CLEAR_DOWNLOAD`,
  payload: type,
});
export const DownloadDumpSwitchFilter = (type) => ({
  type: `SWITCHFILTER`,
  payload: type,
});
export const activeCustomeDateFilter = (type) => ({
  type: `ACTIVECUSTOMEDATE`,
  payload: type,
});
export const ReferrelReport = (payload) => {
  return {
    type: "REFERREL_REPORT",
    payload,
  };
};
export const updateSheduleReport = (schedule, schedeleDatesPayload) => {
  console.log(schedule, "schedeleDatesPayload", schedeleDatesPayload, "123");
  return {
    type: "UPDATE_SCHEDULEREPORTS",
    payload: { schedule, schedeleDatesPayload },
  };
};
export const SheduleReports = (payload) => {
  return {
    type: "SCHEDULE_REPORTS",
    payload,
  };
};

export const clearSheduleReportReportFilter = (type) => ({
  type: `CLEAR_SHEDULEREPORT_FILTER`,
  payload: type,
});
export const ModalPromt = (payload) => {
  return {
    type: "MODAL_PROMT",
    payload,
  };
};
export const updateModalPrompt = (modalPrompt, modalPromptDatesPayload) => {
  return {
    type: "UPDATE_MODAL_PROMT",
    payload: { modalPrompt, modalPromptDatesPayload },
  };
};